import { defineComponent as _defineComponent } from 'vue';
import { ref } from 'vue';
import { VContainer, VRow, VCol, VSimpleTable } from "vuetify/lib";
import DemoSection from '../../components/DemoSection.vue';
import CodePreview from '../../components/CodePreview.vue';
import data from '@/assets/docs/beos-expansion-panel.json';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BeosExpansionPanelDemo',
    setup(__props) {
        const propsDocs = ref(data.props);
        const slotsDocs = ref(data.slots);
        const items = ref([
            { id: 1, name: 'Panel Activo', active: true, info: 'Fondo estándar' },
            { id: 2, name: 'Panel Bloqueado', active: false, info: 'Este panel no se puede abrir' },
            { id: 3, name: 'Panel Especial', active: false, info: 'Fondo personalizado mediante función' }
        ]);
        const basicUsage = `<BeosExpansionPanels :items="items">\n  <template #title="{ data }"> {{ data.name }} </template>\n  <template #text="{ data }"> {{ data.desc }} </template>\n</BeosExpansionPanels>`;
        const advancedUsage = `<BeosExpansionPanels\n  :items="items"\n  :status="(item) => item.active"\n  :disabled-panel-item="(item) => item.id === 2"\n  :background-item="(item) => item.id === 3 ? '#f0f4ff' : '#f2f4f7'"\n>\n  <template #title="{ data }"> {{ data.name }} </template>\n  <template #text="{ data }"> {{ data.info }} </template>\n</BeosExpansionPanels>`;
        const variantUsage = `<BeosExpansionPanels variant="inset" :items="items" />\n<BeosExpansionPanels variant="accordion" :items="items" />`;
        return { __sfc: true, propsDocs, slotsDocs, items, basicUsage, advancedUsage, variantUsage, VContainer, VRow, VCol, VSimpleTable, DemoSection, CodePreview, data };
    }
});
